import { render, staticRenderFns } from "./InaccessibleUniverskinMInformModal.vue?vue&type=template&id=c1ec5292&scoped=true"
import script from "./InaccessibleUniverskinMInformModal.vue?vue&type=script&lang=js"
export * from "./InaccessibleUniverskinMInformModal.vue?vue&type=script&lang=js"
import style0 from "./InaccessibleUniverskinMInformModal.vue?vue&type=style&index=0&id=c1ec5292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ec5292",
  null
  
)

export default component.exports